module.exports = __webpack_public_path__ + "img/login_bg.8b8de709.png";